<template>
<div>
    <h3> サーベイ情報 </h3>
    <v-data-table  :items="items" hide-actions   hide-headers class="elevation-1">
        <template  slot="items" slot-scope="props">
            <tr>
                <td>{{props.item.label}}</td>
                <td>{{props.item.value}}</td>
            </tr>
        </template>
    </v-data-table>
</div>
</template>
<script>
import { unixtimeToFormattedDate} from "@/utils/datetime.js"
export default {
    components: {},
    props: {
        infoItems:{}
    },
    data() {
        return{
        items:[]
        }
    },
    mounted(){
        this.items.push({label:"名前", value:this.infoItems.subjectName})
        this.items.push({label:"評価者数", value:this.infoItems.numOfCoWorker + "人"})
        this.items.push({label:"サーベイ期間", value: unixtimeToFormattedDate(this.infoItems.startDate) + " - " + unixtimeToFormattedDate(this.infoItems.endDate)})
    }
}
</script>